module.exports = __webpack_public_path__ + "static/media/tm-colorit-2-sm.7fc61df6.webp";